const slug = str => {
  str = str.replace(/^\s+|\s+$/g, ""); // Trim
  str = str.toLowerCase();

  // Remove accents, swap ñ for n, etc
  let from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
  let to = "aaaaaeeeeeiiiiooooouuuunc------";

  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, "") // Remove invalid chars
    .replace(/\s+/g, "-") // Collapse whitespace and replace by -
    .replace(/-+/g, "-"); // Collapse dashes

  return str;
};

const ucFirst = str => {
  if (!str) {
    return "";
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
};

const statusLabel = statusCode => {
  const labels = {
    100: "Setup",
    101: "Preprocessing",
    102: "Preprocessed",
    103: "Ready",
    104: "Initializing",
    105: "Reading data",
    106: "Modeling",
    107: "Saving topic model",
    108: "Creating universe",
    109: "Data uploaded",
    200: "Error",
    300: "Preprocess Warnings"
  };

  return labels[statusCode];
};

export default {
  slug,
  ucFirst,
  statusLabel
};
